const currentVersion = "1.1.9"
export default currentVersion